'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _generic = require('../../helpers/generic');

require('./LayerInputFields.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayerInputFields = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(LayerInputFields, _Component);

  function LayerInputFields() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LayerInputFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LayerInputFields.__proto__ || (0, _getPrototypeOf2.default)(LayerInputFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      count: 1,
      colours: [{
        id: 1,
        hex: ''
      }],
      fileList: [],
      tooltipText: '',
      characterCount: 1,
      enableUserMedia: false

      // NOTE: until we update to react 16+, we need to have this in place.
      // React 16+ provides getderivedstatefromprops (https://reactjs.org/docs/react-component.html#static-getderivedstatefromprops)
      // which allows us to update state from props. Currently we have to do it in componentDidMount
      // which causes an extra render.
      /* eslint-disable react/no-did-mount-set-state */
    }, _this.buildColourInputFields = function () {
      var disableFields = _this.props.disableFields;


      var addColour = function addColour() {
        var _this$state = _this.state,
            colours = _this$state.colours,
            count = _this$state.count;

        var updatedCount = count + 1;
        _this.setState({
          count: updatedCount,
          colours: (0, _immutabilityHelper2.default)(colours, {
            $push: [{
              id: updatedCount,
              hex: ''
            }]
          })
        }, function () {
          if (_this.props.onChange) _this.props.onChange(_this.state.colours, 'colours');
        });
      };
      var deleteColour = function deleteColour(id) {
        var colours = _this.state.colours;

        var splicedColours = colours.filter(function (colour) {
          return colour.id !== id;
        });
        _this.setState({
          colours: (0, _immutabilityHelper2.default)(colours, {
            $set: splicedColours
          })
        }, function () {
          if (_this.props.onChange) _this.props.onChange(_this.state.colours, 'colours', _this.state.colours.length === 0);
        });
      };
      var updateColourFieldValue = function updateColourFieldValue(id, value) {
        var colours = _this.state.colours;

        _this.setState({
          colours: (0, _immutabilityHelper2.default)(colours, (0, _defineProperty3.default)({}, colours.findIndex(function (color) {
            return color.id === id;
          }), { $merge: {
              hex: value
            } }))
        }, function () {
          if (_this.props.onChange) _this.props.onChange(_this.state.colours, 'colours');
        });
      };
      var buildColourInputs = function buildColourInputs() {
        var colours = _this.state.colours;

        return colours.map(function (colour) {
          return _react2.default.createElement(
            'div',
            { key: colour.id, className: 'box' },
            _react2.default.createElement('span', {
              className: 'colour-box',
              style: { backgroundColor: colour.hex.includes('#') ? colour.hex : '#' + colour.hex }
            }),
            _react2.default.createElement(_antd.Input, {
              disabled: disableFields,
              className: 'colour-input-box',
              style: { marginBottom: '10px' },
              value: colour.hex,
              suffix: disableFields ? null : _react2.default.createElement(_antd.Icon, { type: 'close', onClick: function onClick() {
                  return deleteColour(colour.id);
                } }),
              onChange: function onChange(e) {
                return updateColourFieldValue(colour.id, e.target.value);
              }
            })
          );
        });
      };
      return _react2.default.createElement(
        'div',
        { className: 'colour-inputs' },
        _react2.default.createElement(
          _antd.Button,
          {
            disabled: disableFields,
            type: 'dashed',
            className: 'add-colour-button',
            onClick: addColour
          },
          'Add Colour'
        ),
        buildColourInputs()
      );
    }, _this.buildMediaInputFields = function () {
      var disableFields = _this.props.disableFields;


      var handleChange = function handleChange(_ref2) {
        var fileList = _ref2.fileList;

        _this.setState({
          fileList: fileList
        }, function () {
          if (_this.props.onChange) _this.props.onChange(_this.state.fileList, 'media', _this.state.fileList.length === 0);
        });
      };

      var toggleUserMediaOnHandle = function toggleUserMediaOnHandle(checked) {
        _this.setState({
          enableUserMedia: checked
        }, function () {
          if (_this.props.onChange) _this.props.onChange(_this.state.enableUserMedia, 'enableUserMedia', false);
        });
      };

      var contentType = _this.props.layer.contentType;


      return _react2.default.createElement(
        'div',
        { className: 'media-inputs' },
        _react2.default.createElement(
          'div',
          { className: 'enable-user-media' },
          _react2.default.createElement(
            'span',
            { className: 'label-text' },
            'Enable User Media'
          ),
          _react2.default.createElement(
            'span',
            { className: 'switch' },
            _react2.default.createElement(_antd.Switch, {
              checked: _this.state.enableUserMedia,
              size: 'small',
              onChange: toggleUserMediaOnHandle
            })
          )
        ),
        _react2.default.createElement(
          _antd.Upload,
          {
            accept: (0, _generic.determineAcceptedAttributes)(contentType),
            action: _this.props.mediaActionUrl,
            customRequest: function customRequest(option) {
              return (0, _generic.upload)(option, _this.props.WSSEToken);
            },
            name: 'mediaFiles',
            fileList: _this.state.fileList,
            onChange: handleChange,
            multiple: true,
            disabled: disableFields,
            showUploadList: {
              showRemoveIcon: !disableFields
            }
          },
          _react2.default.createElement(
            _antd.Button,
            { type: 'dashed', className: 'add-media-button', disabled: disableFields },
            _react2.default.createElement(_antd.Icon, { type: 'upload' }),
            ' Upload Media'
          )
        )
      );
    }, _this.buildTextReadOnlyField = function () {
      var disableFields = _this.props.disableFields;

      var updateCharacterCount = function updateCharacterCount(value) {
        _this.setState({
          characterCount: value
        }, function () {
          if (_this.props.onChange) _this.props.onChange(_this.state.characterCount, 'characterCount', false);
        });
      };

      return _react2.default.createElement(
        'div',
        { className: 'text-inputs' },
        _react2.default.createElement(_antd.Input, {
          className: 'text-box',
          disabled: true,
          value: 'Text',
          suffix: disableFields ? null : _react2.default.createElement(_antd.Icon, { style: { cursor: 'pointer' }, type: 'close', onClick: function onClick() {
              return _this.props.onChange('', '', true);
            } })
        }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'character-count-label' },
            'Character Count'
          ),
          _react2.default.createElement(_antd.InputNumber, {
            min: 1,
            value: _this.state.characterCount,
            onChange: updateCharacterCount,
            disabled: disableFields
          })
        )
      );
    }, _this.buildFields = function () {
      var contentType = _this.props.layer.contentType;

      switch (contentType) {
        case 'COLOR':
          return _this.buildColourInputFields();
        case 'IMAGE':
        case 'VIDEO':
        case 'AUDIO':
          return _this.buildMediaInputFields();
        case 'TEXT':
          return _this.buildTextReadOnlyField();
        default:
          return 'Error, Unknown Field';
      }
    }, _this.buildTooltip = function () {
      var tooltipText = _this.state.tooltipText;

      var updateTooltip = function updateTooltip(e) {
        _this.setState({
          tooltipText: e.target.value
        }, function () {
          if (_this.props.onChange) _this.props.onChange(_this.state.tooltipText, 'tooltip', false);
        });
      };

      return _react2.default.createElement(
        'div',
        { className: 'tooltip-input' },
        _react2.default.createElement(_antd.Input, {
          placeholder: 'Instructions, Tips, etc...',
          value: tooltipText,
          onChange: updateTooltip
        })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LayerInputFields, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var layer = this.props.layer;

      if (layer && layer.media && layer.media.length !== 0) {
        this.setState({
          fileList: layer.media
        });
      } else if (layer && layer.colours && layer.colours.length !== 0) {
        this.setState({
          colours: layer.colours
        });
      }
      // Update tooltip local state if prop contains it
      if (layer.tooltip !== '') this.setState({ tooltipText: layer.tooltip });
      // Update Character Count if prop contains it
      if (layer.characterCount) this.setState({ characterCount: layer.characterCount });

      if (layer.enableUserMedia) this.setState({ enableUserMedia: layer.enableUserMedia });
    }
    /* eslint-enable react/no-did-mount-set-state */

  }, {
    key: 'render',
    value: function render() {
      var disableFields = this.props.disableFields;

      return _react2.default.createElement(
        'div',
        { className: 'LayerInputFields__Component' },
        this.buildTooltip(),
        _react2.default.createElement(
          'div',
          { className: disableFields ? 'disableds' : '' },
          this.buildFields()
        )
      );
    }
  }]);
  return LayerInputFields;
}(_react.Component), _class.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  layer: _propTypes2.default.shape({
    contentType: _propTypes2.default.string.isRequired
  }).isRequired,
  WSSEToken: _propTypes2.default.string,
  mediaActionUrl: _propTypes2.default.string,
  disableFields: _propTypes2.default.bool.isRequired
}, _class.defaultProps = {
  WSSEToken: '',
  mediaActionUrl: ''
}, _temp2);
exports.default = LayerInputFields;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/components/LayerInputFields/index.js
// module id = 3907
// module chunks = 5 6 7 8